import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://xsuruuynxrxrarvalzjb.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhzdXJ1dXlueHJ4cmFydmFsempiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI2MjAzOTQsImV4cCI6MjA2ODE5NjM5NH0.fElwL8sKwveT1Gpb_3IVZt4o3M3DuOxcc-wdcuJO0pY';

// Crear una única instancia del cliente
export const supabase = createClient(supabaseUrl, supabaseAnonKey); 